module.exports = __webpack_public_path__ + "media/images/components/base/container/gradient-hero-banner-mobile-a6f076440e786e4d47868ae072b97397.jpg";